module.exports = __webpack_public_path__ + "media/images/icons/rooms/shower-68a80245783efaa567a44c33aa0b278f.svg";